import { render, staticRenderFns } from "./ResponsiveTable.vue?vue&type=template&id=d77a2ad6&"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js&"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports